<template>
<Upload
   	ref="upload"
   	:show-upload-list="false"
   	:on-success="handleSuccess"
   	:format="['jpg','jpeg','png']"
   	:max-size="20480"
   	:on-exceeded-size="handleMaxSize"
   	:before-upload="handleBeforeUpload"
   	accept="image/gif,image/jpeg,image/png"
   	action="/pc/fileServer/uploadImageReturnThumbnail"
   	class="upload">
   	<!-- <div style="width: 58px;height:58px;line-height: 58px;">
       <Icon type="ios-camera" size="20"></Icon>
   	</div> -->
   	<div class="upload-img">
   		<div class="upload-img-main" v-if="!img">
   			<Icon type="ios-camera" size="20"></Icon>
   			<p>点击上传</p>
   		</div>
   		<Spin fix v-show="uploadLoading"></Spin>
   	    <img class="head-img" :src="ossImg(img,'s')" v-show="img">
   	</div>
   	<div>
   		<a @click.stop="toBig" class="big-img" v-if="img">查看大图</a>
   		<a @click.stop="$emit('on-remove')" class="del-img" v-if="showDel">移除</a>
   	</div>
</Upload>
</template>
<script>
export default {
	props:{
		value:String,
		showDel:Boolean
	},
	data () {
		return {
			img:this.value||'',
			uploadLoading:false
		}
	},
	methods:{
		handleSuccess (res,file){
			if(res.code==10000000){
				this.img = res.data;
				this.$emit('input',res.data);
				this.$emit('on-change',res.data)
			}else{
				this.alert(res.msg)
			}
			this.uploadLoading = false;
		},
		handleMaxSize (file) {
			this.alert('图片过大')
			this.uploadLoading = false;
		},
		handleBeforeUpload (file) {
			this.uploadLoading = true;
		},
		toBig () {
			window.open(this.ossImg(this.img))
		}
	},
	watch:{
		value (val) {
			this.img = val;
		}
	}
}
</script>
<style scoped>
	.upload{
		width:90px;
		display:inline-block;
		text-align:center;
		/*margin-bottom: 5px;*/
		height:142px;
	}
	.upload-img{
		width: 90px;
		height:110px;
		/*line-height: 110px;*/
		/*padding-top: 20px;*/
		border: 1px #eaeaea dashed;
		border-radius: 4px;
		text-align: center;
		position: relative;
	}
	.upload-img-main{
		padding-top: 20px;
	}
	p{
		color:#999
	}
	.head-img{
		width:100%;
		height:100%;
	}
	.del-img{
		color:red;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/UploadImg.vue